import { auth } from "../firebase";

// Login with Firebase
export const login = async (email, password) => {
  try {
    await auth.signInWithEmailAndPassword(email, password);
    return true; // Successful login
  } catch (error) {
    console.error('Login failed:', error);
    return false; // Failed login
  }
};

// Logout
export const logout = () => {
  auth.signOut();
};

// Get the currently logged-in user
export const getCurrentUser = () => {
  return auth.currentUser;
};

// Check if the user is an admin
export const isAdmin = (user) => {
  // Implement your logic to check if the user is an admin
  return user?.email === 'admin@unimates.com';
};


export const sendPasswordResetEmail = async (email) => {
  try {
    await auth.sendPasswordResetEmail(email);
    return true; // Email sent successfully
  } catch (error) {
    console.error('Password reset email sending failed:', error);
    return false; // Failed to send the email
  }
};